import { stringToTitleCase } from '@/utils/functions/stringToTitleCase'
import { UseFormReturn } from 'react-hook-form'
import { getElementDisplayName } from '../../utils/getElementDisplayName'
import { Input } from 'alurkerja-ui'

export type DefaultEditTabElementProps = {
  element: string
  index: number
  form: UseFormReturn<any>
  keyTab: string
  currentElementState: any
  setCurrentElementState: React.Dispatch<any>
}

export default function DefaultEditTabElement(props: Readonly<DefaultEditTabElementProps>) {
  const { element, index, currentElementState, setCurrentElementState, keyTab } = props
  
  return (
    <div key={index} className="p-3 py-2 rounded-sm ">
      <span className="font-semibold">{stringToTitleCase(getElementDisplayName(element))}</span>
      <Input
        className="w-full"
        type="text"
        size="sm"
        rounded="lg"
        value={currentElementState['edit_tabs'][keyTab][element]}
        onChange={(e) => {
          setCurrentElementState((prevState: any) => {
            return {
              ...prevState,
              ['edit_tabs']: {
                ...prevState['edit_tabs'],
                [keyTab]: {
                  ...prevState['edit_tabs'][keyTab],
                  [element]: e.target.value,
                },
              },
            }
          })
        }}
      />
    </div>
  )
}
